module.exports = __webpack_public_path__ + "static/media/catapult.fb72c376.png";